/**
 * Visualisation colours for charts, canvas and other data encodings.
 *
 * Source of truth: .claude/rules/visualisation_colours.md. Brand colours
 * (badger-*) are UI chrome only and must never appear inside a chart.
 */

// Okabe & Ito (2008) — distinguishable under deuteranopia, protanopia and tritanopia
export const OKABE_ITO = {
	amber: '#E69F00',
	skyBlue: '#56B4E9',
	green: '#009E73',
	yellow: '#F0E442', // background fills only — too little contrast for lines or text on white
	blue: '#0072B2',
	vermillion: '#D55E00',
	reddishPurple: '#CC79A7',
	grey: '#999999',
};

// Usage order for lines, bars and points (yellow excluded, see above)
export const CATEGORICAL = [
	OKABE_ITO.amber,
	OKABE_ITO.skyBlue,
	OKABE_ITO.green,
	OKABE_ITO.blue,
	OKABE_ITO.vermillion,
	OKABE_ITO.reddishPurple,
];

// Baselines, averages, annotations and suppressed series
export const NEUTRAL = OKABE_ITO.grey;

export const categoricalColour = (index) => CATEGORICAL[index % CATEGORICAL.length];
